module.exports = __webpack_public_path__ + "img/ofertasvalidasvisado.bc65cddb.png";